import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/footer.scss";
import { CURRENT_SEASON } from "../Constants";

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      {/* Top border line */}
      <div className="footer-top-border"></div>
      
      <div className="container">
        {/* Partners Section */}
        <div className="partners-section">
          <h3>Our Partners</h3>
          <div className="sponsors-grid">
            <a href="https://chhy.dk/" target="_blank" rel="noopener noreferrer">
              <img src="/images/sponsors/ch-hydraulik.png" alt="CH Hydraulik" />
            </a>
            <a href="https://powerstats.dk/" target="_blank" rel="noopener noreferrer">
              <img src="/images/sponsors/powerstats.png" alt="PowerStats" />
            </a>
            <span>
              <img src="/images/sponsors/fadolsmontering.png" alt="Fadølsmontering & Udlejning" />
            </span>
            <a href="https://cooldrinks.dk/" target="_blank" rel="noopener noreferrer">
              <img src="/images/sponsors/cool-drinks.png" alt="Cool Drinks" />
            </a>
            <a href="https://lenesblomsterworld.dk/" target="_blank" rel="noopener noreferrer">
              <img src="/images/sponsors/blue-star.png" alt="Lene's Blomster World" />
            </a>
            <a href="https://waseen.dk/" target="_blank" rel="noopener noreferrer">
              <img src="/images/sponsors/white-logo.png" alt="Waseen" />
            </a>
            <a href="https://www.acezone.io/NCS" target="_blank" rel="noopener noreferrer" className="acezone-sponsor">
              <img src="/images/sponsors/acezone.png" alt="ACEZone" />
            </a>
            <span>
              <img src="/images/sponsors/cpj-ejendomme.png" alt="CPJ Ejendomme" />
            </span>
            <a href="https://demo-slap.net/" target="_blank" rel="noopener noreferrer">
              <svg width="776" height="488" viewBox="0 0 776 488" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="DEMO.SLAP">
                <path d="M0 485.601H37.5083C57.5164 485.601 72.455 480.047 82.8365 469.665C92.0855 460.416 97.0201 448.578 97.0201 435.608C97.0201 425.119 94.054 416.706 87.6363 410.288C81.1108 403.763 70.5944 399.179 53.8222 399.179H23.1899L0 485.601ZM35.6747 460.416L45.3012 424.364H50.101C57.031 424.364 61.3454 425.982 64.0689 428.705C66.28 430.916 67.6552 433.99 67.6552 438.682C67.6552 443.994 65.0396 449.792 61.4802 453.378C57.031 457.827 49.5078 460.416 40.7441 460.416H35.6747Z" fill="white"/>
                <path d="M92.0923 485.601H166.408L172.691 461.899H126.769L129.358 452.515H171.585L177.14 431.644H134.913L137.259 422.881H182.56L189.005 399.179H115.282L92.0923 485.601Z" fill="white"/>
                <path d="M175.172 485.601H203.431L214.918 442.754L226.513 473.494H227.026L255.15 442.754L243.69 485.601H272.435L295.652 399.179H263.914L237.272 429.568L226.891 399.179H198.362L175.172 485.601Z" fill="white"/>
                <path d="M333.792 487.327C362.806 487.327 384.648 463.382 384.648 436.606C384.648 414.495 367.12 397.453 341.692 397.453C312.678 397.453 290.836 421.398 290.836 448.201C290.836 470.285 308.364 487.327 333.792 487.327ZM335.76 461.899C325.406 461.899 319.851 454.726 319.851 445.612C319.851 434.745 327.617 422.881 339.724 422.881C350.079 422.881 355.633 430.053 355.633 439.195C355.633 450.061 347.867 461.899 335.76 461.899Z" fill="white"/>
                <path d="M387.119 458.205H430.074L436.249 435.231H393.294L387.119 458.205Z" fill="#0090EB"/>
                <path d="M474.537 487.327C499.345 487.327 513.664 473.764 513.664 456.344C513.664 443.131 504.28 436.956 489.584 431.537C477.611 427.087 475.751 426.602 475.751 424.013C475.751 421.533 478.366 420.535 482.061 420.535C491.202 420.535 500.451 424.876 507.003 430.161L523.533 410.423C514.149 402.387 500.451 397.453 485.027 397.453C461.432 397.453 446.143 411.043 446.143 427.707C446.143 440.408 453.666 446.098 469.711 452.03C482.303 456.722 483.921 457.585 483.921 460.308C483.921 462.762 481.306 464.11 477.611 464.11C468.47 464.11 458.358 460.173 448.489 451.895L431.933 471.66C442.422 481.152 457.361 487.327 474.537 487.327Z" fill="#0090EB"/>
                <path d="M512.679 485.601H580.928L587.615 460.901H548.219L564.776 399.179H535.869L512.679 485.601Z" fill="#0090EB"/>
                <path d="M581.063 485.601H612.532L620.082 474.006H650.31L651.793 485.601H682.533L669.455 398.585H640.818L581.063 485.601ZM632.917 453.513L646.373 432.507L648.719 453.513H632.917Z" fill="#0090EB"/>
                <path d="M684.642 485.601H713.521L719.831 462.142H732.046C759.443 462.142 775.729 447.716 775.729 426.09C775.729 419.321 773.518 413.254 768.961 408.697C762.517 402.28 752.782 399.179 736.846 399.179H707.832L684.642 485.601ZM725.386 441.541L730.428 422.261H735.875C739.084 422.261 742.535 423.016 744.504 424.984C745.852 426.359 746.607 428.193 746.607 430.053C746.607 436.606 741.538 441.541 730.563 441.541H725.386Z" fill="#0090EB"/>
                <path d="M374.796 154.21C353.506 191.208 332.227 228.207 310.917 265.185C303.818 277.518 296.539 289.752 289.648 302.194C287.275 306.484 284.534 308.698 279.4 308.559C268.179 308.251 256.949 308.36 245.728 308.499C240.823 308.559 239.244 306.732 239.254 301.648C239.472 203.66 239.492 105.673 239.562 7.68567C239.562 5.29259 239.562 2.8995 239.562 0H381.28C351.739 51.2577 322.744 101.552 293.004 153.128C296.767 153.376 299.309 153.684 301.851 153.694C322.923 153.733 344.004 153.694 365.075 153.743C368.341 153.753 371.608 154.111 374.885 154.309" fill="#0090EB"/>
                <path d="M374.885 154.309C390.653 126.764 406.392 99.2087 422.191 71.6832C431.177 56.0239 440.243 40.4043 449.309 24.7748C450.639 22.4711 452.139 20.2667 453.519 18.102C509.841 44.0287 555.687 121.144 528.35 202.499C502.344 279.891 425.914 314.1 369.235 306.652C398.379 256.12 427.245 206.063 457.143 154.21H374.796" fill="#0090EB"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Three-column layout for footer content */}
        <div className="footer-content">
          {/* Quick Links Column */}
          <div className="footer-column quick-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/leaderboard">Stats</Link></li>
              <li><Link to={`/matches?tab=bracket&season=${CURRENT_SEASON}`}>Standings</Link></li>
              <li><Link to="/teams">Teams</Link></li>
              <li><Link to="/info/schedule">Schedule</Link></li>
            </ul>
          </div>

          {/* Information Column */}
          <div className="footer-column information">
            <h3>Information</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/info/rules">Rules & Regulations</Link></li>
              <li><Link to="/info/format">Format</Link></li>
              <li><Link to="/info/prizepool">Prize Pool</Link></li>
              <li><Link to="/info/faq">FAQ</Link></li>
            </ul>
          </div>

          {/* Get in Touch Column */}
          <div className="footer-column get-in-touch">
            <h3>Get in Touch</h3>
            <p className="contact-email">
              <span>Email:</span>
              <a href="mailto:admin@ncseries.gg">admin@ncseries.gg</a>
            </p>
            
            <div className="social-links">
              <a href="https://x.com/NCS_GameON" target="_blank" rel="noopener noreferrer" className="social-btn twitter-btn">
                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4l11.733 16h4.267l-11.733 -16z"></path>
                  <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"></path>
                </svg>
              </a>
              <a href="https://discord.gg/Uq49hSBFu9" target="_blank" rel="noopener noreferrer" className="social-btn discord-btn">
                <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M8 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
                  <path d="M14 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
                  <path d="M15.5 17c0 1 1.5 3 2 3c1.5 0 2.833 -1.667 3.5 -3c.667 -1.667 .5 -5.833 -1.5 -11.5c-1.457 -1.015 -3 -1.34 -4.5 -1.5l-.972 1.923a11.913 11.913 0 0 0 -4.053 0l-.975 -1.923c-1.5 .16 -3.043 .485 -4.5 1.5c-2 5.667 -2.167 9.833 -1.5 11.5c.667 1.333 2 3 3.5 3c.5 0 2 -2 2 -3"></path>
                  <path d="M7 16.5c3.5 1 6.5 1 10 0"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="footer-bottom">
          <div className="copyright">
            &copy; {new Date().getFullYear()} Northern Championships Series. All rights reserved.
          </div>
          <div className="legal-links">
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/cookies">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;